export default "__VITE_ASSET__0468d84c__"